import { render, staticRenderFns } from "./show.vue?vue&type=template&id=34960a40&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=34960a40&lang=scss&scoped=true&"
import style1 from "./show.vue?vue&type=style&index=1&id=34960a40&lang=scss&scoped=true&"
import style2 from "./show.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34960a40",
  null
  
)

export default component.exports